import AiLoader from "@dashboard/modules/shared/components/onboarding-shared/pages/ai-loader/ai-loader";
import { FC } from "react";

const OnboardingGuestGenerating: FC = () => {
  return <AiLoader redirectPath="/onboarding-guest/personalize?onboarding=split2" />;
};

export default OnboardingGuestGenerating;
